import { USER_AGENTS } from 'tangle-shared'
import { Platform } from 'interfaces/global'
import { isFeatureEnabled } from 'helpers/featureHelpers'

const ua = navigator.userAgent

export const UA_VERSION = getVersion()

export const IS_IOS = /iP(hone|ad|od)/.test(ua)
export const IS_IOS_LT_13 = Boolean(IS_IOS && UA_VERSION.major && UA_VERSION.major < 13)
export const IS_ANDROID = /Android/.test(ua)
export const IS_IE_MOBILE = /IEMobile/.test(ua)
export const IS_IE_DESKTOP = !IS_IE_MOBILE && /Trident/.test(ua)
export const IS_IE = IS_IE_MOBILE || IS_IE_DESKTOP
export const IS_EDGE = /Edge/.test(ua)
export const IS_FIREFOX = /Firefox/.test(ua)
export const IS_MOBILE = IS_IOS || IS_ANDROID || IS_IE_MOBILE

export const IS_STATUS_APP = ua.includes(USER_AGENTS.mobileAppPrefix) || isFeatureEnabled('app')
export const IS_STATUS_APP_IOS = IS_STATUS_APP && IS_IOS
export const IS_STATUS_APP_ANDROID = IS_STATUS_APP && IS_ANDROID

export const getPlatform = (): Platform | null => {
  if (!IS_STATUS_APP) {
    return 'web'
  }

  if (IS_STATUS_APP_IOS) {
    return 'ios'
  }

  if (IS_STATUS_APP_ANDROID) {
    return 'android'
  }

  return null
}

function getVersion () {
  const parts = navigator.userAgent.match(/Version\/(\d+)\.(\d+)(?:\.(\d+))?/) || []
  // don't pass `parseInt` directly to `map`. it works incorrect
  // tslint:disable-next-line:no-unnecessary-callback-wrapper
  const [, major, minor, patch] = parts.map((n) => parseInt(n, 10))

  return {
    major: major || null,
    minor: minor || null,
    patch: patch || null,
  }
}
